import { SET_MESSAGE_NOTIFICATION_ACTION_TYPE } from './actions';

const defaultState = {
  message: null,
  duration: 2000,
};

const AlertReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_MESSAGE_NOTIFICATION_ACTION_TYPE: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

export default AlertReducer;
